"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _header = require("./header");

var _header2 = _interopRequireDefault(_header);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _header2.default;